import React from 'react';
import { motion } from 'framer-motion';
interface Mockup3DProps {
  title?: string;
  subtitle?: string;
  className?: string;
  variant?: 'main' | 'bonus';
  color?: 'navy' | 'gold' | 'slate' | 'beige';
}
export function Mockup3D({
  title = 'Volvé a Calmar tu Mente en 21 Días',
  subtitle = 'MÉTODO PRÁCTICO',
  className = '',
  variant = 'main',
  color = 'navy'
}: Mockup3DProps) {
  const getBgColor = () => {
    switch (color) {
      case 'navy':
        return 'bg-navy';
      case 'gold':
        return 'bg-gold-dark';
      case 'slate':
        return 'bg-slate';
      case 'beige':
        return 'bg-beige-dark';
      default:
        return 'bg-navy';
    }
  };
  const getTextColor = () => {
    return color === 'beige' ? 'text-navy' : 'text-beige-light';
  };
  const getAccentColor = () => {
    return color === 'navy' ? 'border-gold' : 'border-beige-light/30';
  };
  return <motion.div className={`book-container ${className}`} animate={{
    y: [0, -10, 0]
  }} transition={{
    repeat: Infinity,
    duration: 6,
    ease: 'easeInOut'
  }} data-id="element-98">
      <div className="book w-full h-full" style={{
      transform: 'rotateY(-25deg) rotateX(5deg)'
    }} data-id="element-99">
        {/* Front Cover */}
        <div className={`book-front ${getBgColor()} flex flex-col items-center justify-between p-6 md:p-8 text-center border-l-4 border-black/20`} data-id="element-100">
          <div className="w-full" data-id="element-101">
            <div className={`text-[10px] md:text-xs tracking-[0.2em] mb-4 ${getTextColor()} opacity-80 font-sans uppercase`} data-id="element-102">
              {subtitle}
            </div>
            <div className={`w-12 h-[1px] mx-auto mb-6 border-t ${getAccentColor()}`} data-id="element-103"></div>
            <h3 className={`font-serif text-xl md:text-3xl lg:text-4xl leading-tight ${getTextColor()}`} data-id="element-104">
              {title}
            </h3>
          </div>

          <div className="w-full mt-8" data-id="element-105">
            <div className={`w-8 h-8 mx-auto rounded-full border border-current opacity-50 flex items-center justify-center ${getTextColor()}`} data-id="element-106">
              <span className="font-serif text-xs" data-id="element-107">M</span>
            </div>
          </div>

          {/* Subtle overlay for realism */}
          <div className="absolute inset-0 bg-gradient-to-tr from-black/20 via-transparent to-white/10 pointer-events-none" data-id="element-108"></div>
        </div>

        {/* Spine */}
        <div className="book-spine flex items-center justify-center" data-id="element-109">
          <span className="text-[8px] text-white/50 tracking-widest whitespace-nowrap" style={{
          transform: 'rotate(90deg)'
        }} data-id="element-110">
            MERCURY EDITORIAL
          </span>
        </div>

        {/* Pages */}
        <div className="book-pages-top" data-id="element-111"></div>
        <div className="book-pages-right" data-id="element-112"></div>

        {/* Back Cover */}
        <div className="book-back" data-id="element-113"></div>
      </div>
    </motion.div>;
}